<template>
  <b-modal
    id="page-reorder-modal"
    :title="trans('reorder_items')"
    :ok-title="trans('save')"
    :cancel-title="trans('cancel')"
    no-close-on-backdrop
    size="lg"
    @ok="onSave"
    @show="loadItems"
    :ok-disabled="busy"
  >
    <p class="lead">{{ trans('drag_drop_to_reorder') }}</p>

    <div class="pages">
      <page-nested-draggable
        :pages="pages"
        @sort="onSort"
      ></page-nested-draggable>
    </div>

    <p v-if="busy">
      <i class="fa fa-fw fa-circle-notch fa-spin"></i>
      {{ trans('please_wait') }}
    </p>
    <p v-if="error" class="text-danger">
      {{ error }}
    </p>
  </b-modal>
</template>

<script>
  import PageNestedDraggable from './PageNestedDraggable'

  export default {
    props: {
      organization: Object,
      isStaff: Boolean,
    },
    components: {
      PageNestedDraggable,
    },
    data() {
      return {
        trans: trans,
        busy: false,
        error: null,
        pages: null,
      }
    },
    methods: {
      deserialize(pages) {
        return _.reduce(pages, (result, p) => {
          let page = _.clone(p)
          if (!page.page_id) {
            page.pages = _.filter(pages, {page_id: page.id}) 
            result.push(page)
          }
          return result
        }, [])
      },
      serialize(result, pages, parent_id) {
        return _.reduce(pages || this.pages, (result, page) => {
          result.push({
            id: page.id,
            name: page.name,
            page_id: parent_id || null,
          })
          if (page.pages && page.pages.length > 0) {
            return this.serialize(result, page.pages, page.id)
          }
          return result
        }, result || [])
      },
      onSort() {
        let pages = this.serialize()
        this.pages = this.deserialize(pages)
      },
      onSave(e) {
        e.preventDefault()
        this.busy = true
        this.error = null
        const url = `/organization/${this.organization.id}/page/reorder`
        const pages = this.serialize()
        axios.post(url, {pages: pages})
        .then(response => {
          this.busy = false
          this.$emit('saved', response.data)
          this.$bvModal.hide('page-reorder-modal')
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
          _.toastError(this, this.error)
        })
      },
      loadItems() {
        this.busy = true
        this.error = null
        let url = `/organization/${this.organization.id}/page/list?per_page=300&is_staff=${this.isStaff ? 'true' : 'false'}`
        axios.get(url)
        .then(response => {
          this.busy = false
          this.pages = this.deserialize(response.data.data)
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
          _.toastError(this, this.error)
        })
      }
    },
    mounted() {
      window.pageReorderModal = this
    },
  }
</script>